import React, { useCallback, useEffect, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { setHarvestingContentView } from 'redux/reducers/synchrotronTripReducer';
import { useAssignSoakingToCrystals, useSoakingAgents } from './hooks';
import SelectAgents from './selectAgents';

const SelectSoaking = () => {
  const dispatch = useRMDispatch();
  const soakingAgents = useSoakingAgents();
  const [soakingList, setSoakingList] = useState([]);
  const applySoaking = useAssignSoakingToCrystals(
    soakingList?.filter((x) => x.checked)?.map((x) => x.id),
  );

  useEffect(() => {
    if (soakingAgents?.length) {
      setSoakingList(soakingAgents);
    }
  }, [soakingAgents]);

  const onSelectSoaking = (id: number) => {
    setSoakingList(
      soakingList?.map((soaking) => {
        if (soaking.id === id) {
          return { ...soaking, checked: !soaking.checked };
        }
        return soaking;
      }),
    );
  };

  const handleBackToPreviousScreen = useCallback(
    (contentView) => () => {
      dispatch(setHarvestingContentView(contentView));
    },
    [],
  );

  return (
    <SelectAgents
      agentsList={soakingList}
      handleBackToPreviousScreen={handleBackToPreviousScreen}
      onSelectAgent={onSelectSoaking}
      applyChanges={applySoaking}
    />
  );
};

export default SelectSoaking;
